import template from './indirectRateModal.html';
import controller from './indirectRateModal.controller';

let IndirectRateModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

export default IndirectRateModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/indirectRateModal/indirectRateModal.component.js